/**
 * Topic → curated stock image mapping.
 * Maps onboarding topic answers to relevant Unsplash images used on the
 * right-side preview panel of OnboardingWizard.
 *
 * All URLs are public Unsplash hotlinks (Source URLs allowed for any use).
 */

export const TOPIC_IMAGES = {
  'Photography':           'https://images.unsplash.com/photo-1452587925148-ce544e77e70d?w=1200&q=80',
  'Beadwork & Craft':      'https://images.unsplash.com/photo-1606141546829-eebf9b73c562?w=1200&q=80',
  'Fashion & Apparel':     'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1200&q=80',
  'Music':                 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=1200&q=80',
  'Film & Video':          'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=1200&q=80',
  'Public Speaking':       'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=1200&q=80',
  'Coaching':              'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80',
  'Construction':          'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1200&q=80',
  'Wellness & Healing':    'https://images.unsplash.com/photo-1545205597-3d9d02c29597?w=1200&q=80',
  'Non-Profit Organization': 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=1200&q=80',
  'Restaurant & Food':     'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200&q=80',
  'Art & Painting':        'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=1200&q=80',
  'Workshops & Camps':     'https://images.unsplash.com/photo-1529390079861-591de354faf5?w=1200&q=80',
  'Event Organizing':      'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=1200&q=80',
  'Design Studio':         'https://images.unsplash.com/photo-1561070791-2526d30994b8?w=1200&q=80',
  'Consulting':            'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1200&q=80',
};

/** Generic fallback used when topic isn't recognised. */
export const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&q=80';

export const imageForTopic = (topic) => TOPIC_IMAGES[topic] || FALLBACK_IMAGE;
